import { ColumnKey_FloatingLeft, ColumnKey_FloatingMiddle, ColumnKey_FloatingRight, ColumnKey_LeftColumn, ColumnKey_MiddleColumn, ColumnKey_RightColumn, PanelKey_AddProtocolData, PanelKey_Findings, PanelKey_Home, PanelKey_NextSteps, PanelKey_ProtocolInfo, PanelKey_ProvideInfo, PanelKey_EventFeed, PanelKey_Settings, PanelKey_SmartDocs, PanelKey_Spotlight } from './types.js';
export const CollapsedPanelHeight = 48;
export const HomePanelHeight = 32;
export const SettingPanelHeight = 32;
// column sizes
export const ColumnRatio_Hidden = 0;
export const ColumnRatio_OneThird = 1 / 3;
export const ColumnRatio_TwoThirds = 2 / 3;
export const ColumnRatio_Full = 1;
//######################### Column States - Right #########################
export const RightColumnNew_Base = [
    { height: 1, panelKey: PanelKey_NextSteps },
    { height: 0, panelKey: PanelKey_AddProtocolData },
];
export const RightColumnNew_AddData = [
    { height: 1, panelKey: PanelKey_NextSteps },
    { height: 400, panelKey: PanelKey_AddProtocolData },
];
//######################### Column States - Middle #########################
export const MiddleColumn_Full = {
    [ColumnKey_RightColumn]: { width: ColumnRatio_Hidden },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_Full },
    [ColumnKey_LeftColumn]: { width: ColumnRatio_Hidden },
};
export const MiddleColumn_TwoThirdsLeft = {
    [ColumnKey_RightColumn]: { width: ColumnRatio_OneThird },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_TwoThirds },
    [ColumnKey_LeftColumn]: { width: ColumnRatio_Hidden },
};
export const MiddleColumn_TwoThirdsRight = {
    [ColumnKey_RightColumn]: { width: ColumnRatio_Hidden },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_TwoThirds },
    [ColumnKey_LeftColumn]: { width: ColumnRatio_OneThird },
};
// middle panel items
export const MiddleColumn_Findings = [
    { panelKey: PanelKey_ProvideInfo, height: 0 },
    { panelKey: PanelKey_Spotlight, height: 0 },
    { panelKey: PanelKey_Findings, height: 1 },
];
export const MiddleColumn_Spotlight = [
    { panelKey: PanelKey_ProvideInfo, height: 0 },
    { panelKey: PanelKey_Spotlight, height: 1 },
    { panelKey: PanelKey_Findings, height: 0 },
];
export const MiddleColumn_ProvideInfo = [
    { panelKey: PanelKey_ProvideInfo, height: 1 },
    { panelKey: PanelKey_Spotlight, height: 0 },
    { panelKey: PanelKey_Findings, height: 0 },
];
//######################### Column States - Left #########################
export const LeftColumn_TwoThirds = {
    [ColumnKey_RightColumn]: { width: ColumnRatio_OneThird },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_Hidden },
    [ColumnKey_LeftColumn]: { width: ColumnRatio_TwoThirds },
};
export const LeftColumn_Full = {
    [ColumnKey_RightColumn]: { width: ColumnRatio_Hidden },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_Hidden },
    [ColumnKey_LeftColumn]: { width: ColumnRatio_Full },
};
// Left Panel items
export const LeftColumn_AllClosed = [
    { height: 1, panelKey: PanelKey_Home },
    { height: 0, panelKey: PanelKey_ProtocolInfo },
    { height: 0, panelKey: PanelKey_SmartDocs },
    { height: 0, panelKey: PanelKey_EventFeed },
    { height: SettingPanelHeight, panelKey: PanelKey_Settings },
];
export const LeftColumn_SmartDocsOpen = [
    { height: HomePanelHeight, panelKey: PanelKey_Home },
    { height: 0, panelKey: PanelKey_ProtocolInfo },
    { height: 1, panelKey: PanelKey_SmartDocs },
    { height: 0, panelKey: PanelKey_EventFeed },
    { height: SettingPanelHeight, panelKey: PanelKey_Settings },
];
export const LeftColumn_EventFeedOpen = [
    { height: HomePanelHeight, panelKey: PanelKey_Home },
    { height: 0, panelKey: PanelKey_ProtocolInfo },
    { height: 0, panelKey: PanelKey_SmartDocs },
    { height: 1, panelKey: PanelKey_EventFeed },
    { height: SettingPanelHeight, panelKey: PanelKey_Settings },
];
// defaults modes
export const defaultAdvisorBoard = {
    [ColumnKey_LeftColumn]: { width: ColumnRatio_OneThird, columnItems: LeftColumn_AllClosed },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_OneThird, columnItems: MiddleColumn_Findings },
    [ColumnKey_RightColumn]: { width: ColumnRatio_OneThird, columnItems: RightColumnNew_Base },
    [ColumnKey_FloatingLeft]: { width: ColumnRatio_OneThird, columnItems: [] },
    [ColumnKey_FloatingMiddle]: { width: ColumnRatio_OneThird, columnItems: [] },
    [ColumnKey_FloatingRight]: { width: ColumnRatio_OneThird, columnItems: [] },
};
export const defaultColumnWidthUpdate = {
    [ColumnKey_LeftColumn]: { width: ColumnRatio_OneThird },
    [ColumnKey_MiddleColumn]: { width: ColumnRatio_OneThird },
    [ColumnKey_RightColumn]: { width: ColumnRatio_OneThird },
};
// general
export const AdvisorPadding = 32;
//# sourceMappingURL=consts.js.map